/*
 * cart-drawer.js — slide-in cart replacing the /cart full-page redirect.
 * Uses Shopify ajax cart endpoints. Falls back gracefully to /cart for
 * no-JS users.
 * P2-026.
 */
(function () {
  'use strict';

  var queue = Promise.resolve();
  var pending = 0;
  var returnFocus = null;
  var previousOverflow = '';
  var background = [];
  var drawer;

  function route(path) {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path;
  }

  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(Number(cents) / 100);
  }

  function message(text) {
    var el = drawer.querySelector('[data-cart-drawer-error]');
    if (el) {
      el.textContent = text || '';
      el.hidden = !text;
    }
    var retry = drawer.querySelector('[data-cart-drawer-retry]');
    if (retry) retry.hidden = !text;
  }

  function request(path, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, 15000);
    return fetch(route(path), Object.assign({}, options, { signal: controller.signal }))
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || (data.status && data.status >= 400)) {
            throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
          }
          return data;
        });
      })
      .finally(function () {
        clearTimeout(timer);
      });
  }

  function schedule(work) {
    pending += 1;
    drawer.setAttribute('aria-busy', 'true');
    var result = queue.then(function () {
      message('');
      return work();
    });
    queue = result
      .catch(function (error) {
        message(
          error.message === 'Failed to fetch' || error.name === 'AbortError'
            ? 'Connection interrupted. Refresh your cart to check its contents before trying again.'
            : error.message || 'Unable to update your cart. Please try again.',
        );
      })
      .finally(function () {
        pending -= 1;
        drawer.setAttribute('aria-busy', pending ? 'true' : 'false');
      });
    return queue;
  }

  function focusControl(key, action) {
    var control = Array.from(drawer.querySelectorAll('[data-cd-key]')).find(function (el) {
      return el.getAttribute('data-cd-key') === key && el.getAttribute('data-cd-qty') === action && !el.disabled;
    });
    (control || drawer.querySelector('[data-cart-drawer-close][type="button"]')).focus();
  }

  function escapeHTML(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function render(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-foot]');
    if (!body || !foot) return;

    var focused = document.activeElement;
    var key = focused && focused.getAttribute('data-cd-key');
    var action = focused && focused.getAttribute('data-cd-qty');
    var count = document.getElementById('cartCount');
    if (count) {
      count.textContent = cart.item_count;
      count.hidden = !cart.item_count;
      count.style.display = cart.item_count ? '' : 'none';
    }
    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cd-empty">' +
        '<strong>Your cart is empty.</strong>' +
        '<span>Need help choosing texture, length, or samples? We can guide you.</span>' +
        '</div>';
      foot.innerHTML =
        '<a class="cd-checkout" href="/collections/all">Shop hair</a>' +
        '<a class="cd-secondary" href="/pages/contact-us">Ask for guidance</a>';
      if (key) focusControl(key, action);
      return;
    }

    body.innerHTML = cart.items
      .map(function (item) {
        var img = (item.featured_image && item.featured_image.url) || item.image || '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return (
          '<div class="cd-item">' +
          '<img src="' +
          escapeHTML(img) +
          '" alt="" loading="lazy">' +
          '<div>' +
          '<div class="cd-item__title">' +
          escapeHTML(item.product_title) +
          '</div>' +
          (variant ? '<div class="cd-item__variant">' + escapeHTML(variant) + '</div>' : '') +
          '<div class="cd-qty">' +
          '<button type="button" aria-label="Decrease quantity of ' +
          escapeHTML(item.product_title) +
          '" data-cd-qty="-1" data-cd-key="' +
          escapeHTML(item.key) +
          '"' +
          (item.quantity <= 1 ? ' disabled aria-disabled="true"' : '') +
          '>&minus;</button>' +
          '<span>' +
          escapeHTML(item.quantity) +
          '</span>' +
          '<button type="button" aria-label="Increase quantity of ' +
          escapeHTML(item.product_title) +
          '" data-cd-qty="+1" data-cd-key="' +
          escapeHTML(item.key) +
          '">+</button>' +
          '</div>' +
          '<button type="button" class="cd-remove" data-cd-remove data-cd-key="' +
          escapeHTML(item.key) +
          '" aria-label="Remove ' +
          escapeHTML(item.product_title) +
          '">Remove</button>' +
          '</div>' +
          '<div class="cd-line-total">' +
          money(item.final_line_price, cart.currency) +
          '</div>' +
          '</div>'
        );
      })
      .join('');

    foot.innerHTML =
      '<div class="cd-totals"><span>Subtotal</span><strong>' +
      money(cart.total_price, cart.currency) +
      '</strong></div>' +
      '<a class="cd-checkout" href="/checkout" data-prarvi-event="checkout_start" data-prarvi-placement="cart_drawer" data-prarvi-audience="retail">Secure checkout &rarr;</a>' +
      '<a class="cd-secondary" href="' +
      route('cart') +
      '">View cart</a>' +
      '<a class="cd-secondary" href="/collections/all">Continue shopping</a>' +
      '<div class="cd-trust" role="group" aria-label="Cart support notes">' +
      '<span>Secure checkout</span>' +
      '<span>Request returns within 7 days of delivery for eligible unused items. <a href="/pages/return-policy">Return policy and exclusions</a></span>' +
      '<span>Need help? <a href="/pages/contact-us">Contact Prarvi</a></span>' +
      '</div>';
    if (key) focusControl(key, action);
  }

  function refresh() {
    return schedule(function () {
      return request('cart.js').then(render);
    });
  }

  function open() {
    if (!drawer) return;
    if (drawer.hidden) {
      returnFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      background = [];
      var branch = drawer;
      while (branch.parentElement) {
        Array.from(branch.parentElement.children).forEach(function (el) {
          if (el !== branch && !['SCRIPT', 'STYLE', 'LINK'].includes(el.tagName)) {
            background.push({ el: el, inert: el.inert });
            el.inert = true;
          }
        });
        branch = branch.parentElement;
        if (branch === document.body) break;
      }
      drawer.hidden = false;
      if (typeof drawer.showModal === 'function') drawer.showModal();
      drawer.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      drawer.querySelector('button[data-cart-drawer-close]').focus();
    }
    return refresh();
  }

  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.removeAttribute('data-open');
    if (typeof drawer.close === 'function') drawer.close();
    drawer.hidden = true;
    background.forEach(function (entry) {
      entry.el.inert = entry.inert;
    });
    background = [];
    document.body.style.overflow = previousOverflow;
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
  }

  function changeQty(key, delta, remove) {
    return schedule(function () {
      return request('cart.js').then(function (cart) {
        var line = cart.items.find(function (item) {
          return item.key === key;
        });
        if (!line) {
          render(cart);
          return;
        }
        var quantity = remove ? 0 : Math.max(1, line.quantity + delta);
        return request('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        }).then(render);
      });
    });
  }

  function init() {
    var d = document.querySelector('[data-cart-drawer]');
    if (!d) return;
    drawer = d;
    d.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });

    // Expose refresh globally so main-cart.liquid can trigger it
    window.Prarvi = window.Prarvi || {};
    window.Prarvi.refreshCartDrawer = refresh;
    window.Prarvi.openCartDrawer = open;
    window.Prarvi.closeCartDrawer = close;

    // Listen for custom update event
    document.addEventListener('prarvi:cart:updated', refresh);
    document.addEventListener('prarvi:cart:open', open);
    d.querySelector('[data-cart-drawer-retry]').addEventListener('click', refresh);

    d.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    d.addEventListener('click', function (e) {
      if (pending && e.target.closest('.cd-checkout')) {
        e.preventDefault();
        return;
      }
      var removeBtn = e.target.closest('[data-cd-remove]');
      if (removeBtn) {
        changeQty(removeBtn.getAttribute('data-cd-key'), 0, true);
        return;
      }
      var qtyBtn = e.target.closest('[data-cd-qty]');
      if (qtyBtn) {
        var delta = parseInt(qtyBtn.getAttribute('data-cd-qty'), 10);
        var key = qtyBtn.getAttribute('data-cd-key');
        changeQty(key, delta);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (d.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      }
      if (e.key === 'Tab') {
        var controls = Array.from(d.querySelectorAll('a[href], button, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && el.getClientRects().length;
        });
        var first = controls[0],
          last = controls[controls.length - 1];
        if (e.shiftKey && (document.activeElement === first || !d.contains(document.activeElement))) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && (document.activeElement === last || !d.contains(document.activeElement))) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // Intercept Add to Cart forms — POST via ajax, then open drawer
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        var action = (form.getAttribute('action') || '').split('?')[0];
        if (action !== route('cart/add')) return;
        // Skip if the form opts out
        if (form.getAttribute('data-no-drawer') === 'true') return;
        e.preventDefault();
        if (form.dataset.cartSubmitting) return;
        form.dataset.cartSubmitting = 'true';
        var fd = new FormData(form);
        request('cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (data) {
            if (window.Prarvi && typeof window.Prarvi.track === 'function') {
              var title = data && (data.product_title || data.title) ? data.product_title || data.title : '';
              window.Prarvi.track('add_to_cart_success', {
                product_title: title,
                variant_id: data && (data.variant_id || data.id) ? data.variant_id || data.id : fd.get('id') || '',
                product_id: data && data.product_id ? data.product_id : '',
                quantity: data && data.quantity ? data.quantity : fd.get('quantity') || '1',
                value: data && data.final_price ? data.final_price / 100 : '',
                currency: window.Shopify && Shopify.currency ? Shopify.currency.active : '',
                product_funnel: title.toLowerCase().indexOf('sample') > -1 ? 'sample' : 'full_size',
                sample: title.toLowerCase().indexOf('sample') > -1,
                audience: 'retail',
                placement: 'cart_drawer_form_intercept',
              });
            }
            open();
          })
          .catch(function (error) {
            if (window.Prarvi && typeof window.Prarvi.track === 'function') {
              window.Prarvi.track('add_to_cart_error', {
                variant_id: fd.get('id') || '',
                quantity: fd.get('quantity') || '1',
                audience: 'retail',
                placement: 'cart_drawer_form_intercept',
              });
            }
            // Never automatically repeat a POST after an ambiguous network failure.
            open().then(function () {
              message(error.message + ' Check your cart before trying again.');
            });
          })
          .finally(function () {
            delete form.dataset.cartSubmitting;
          });
      },
      true,
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
